import {PASSWORD_STRENGTHS} from "./PasswordStrengths";

export const PASSWORD_STRENGTH_CONDITIONS= [
  {
    strengthEvaluation: function(strength) {
      return strength < 1;
    },
    strength: PASSWORD_STRENGTHS.NONE
  },
  {
    strengthEvaluation: function(strength) {
      return strength > 0 && strength <= 2;
    },
    strength: PASSWORD_STRENGTHS.WEAK
  },
  {
    strengthEvaluation: function(strength) {
      return strength > 2 && strength <= 4;
    },
    strength: PASSWORD_STRENGTHS.MODERATE
  },
  {
    strengthEvaluation: function(strength) {
      return strength > 4;
    },
    strength: PASSWORD_STRENGTHS.STRONG
  }
];